<template>
	<div class="d-flex flex-row align-center justify-space-between">
		<div class="d-flex align-center justify-space-between flex-1" style="gap: 5px;width: 100%;">
			<p class="mb-0 caption"><b>Pagos</b></p>

			<v-progress-linear :value="payedPercentage*100" color="primary" height="10" rounded style="max-width: 75px;">
				<p class="mb-0" style="font-size: 9px;" :class="payedPercentage < 0.43 ? '':'white--text'">{{ Math.round(payedPercentage*100) }}%</p>
			</v-progress-linear>
		</div>

		<v-menu
			v-model="menuPayments"
			offset-y
			:close-on-content-click="false"
			min-width="450px">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					dark
					small
					color="#2D4B95"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark small>mdi-credit-card-search-outline</v-icon>
				</v-btn>
			</template>
			<div class="white py-2 px-4">
				<div class="d-flex align-center justify-space-between gray lighten-4 px-2">
					<p class="mb-0 font-weight-bold caption">Pagos realizados para este Estado de Pago (Nº{{item.originalIndex + 1}})</p>
					<v-btn
						icon
						small
						@click="menuPayments = false"
					>
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</div>
				<v-divider class="my-1"></v-divider>
				<div v-if="item.payments && item.payments.length > 0">
					<div v-for="(payment, index) in item.payments" :key="index">
						<div class="d-flex flex-row justify-space-between align-center my-2">
							<div>
								<p class="mb-0 caption"><b>Monto:</b> {{prependToValue}}{{payment.amount_converted | toThousandFilter(payment.currency_info?.code === 'UF' ? 2 : 0)}}</p>
								<p class="mb-0 caption"><b>Fecha de Pago:</b> {{new Date(payment.payment_info.payment_date).toLocaleDateString('es-CL')}}</p>
								<p class="mb-0 caption"><b>Concepto:</b> {{payment.concept}}</p>
								<p class="mb-0 caption"><b>Forma de Pago:</b> {{payment.payment_info.method}}</p>
							</div>
							<div v-if="payment.payment_info && payment.payment_info.file && payment.payment_info.file.pathmedia">
								<v-btn
									depressed
									color="#524D4D"
									small
									outlined
									:href="payment.payment_info.file.pathmedia.path"
									target="_blank"
								>
									<v-icon small>mdi-file-document-outline</v-icon>
									<p class="mb-0 ml-2 caption">Comprobante</p>
								</v-btn>
							</div>
						</div>
						<v-divider class="my-1" v-if="index < item.payments.length - 1" ></v-divider>
					</div>
				</div>
				<div v-else-if="!showPaymentForm" class="text-center py-4">
					<v-icon color="text--secondary" size="32">mdi-cash-multiple</v-icon>
					<p class="mb-0 caption text--secondary mt-2">No hay pagos registrados</p>
				</div>
				<div v-if="showPaymentForm" class="mt-1 px-0">
					<v-form ref="form" v-model="validform" class="mt-6">
						<v-text-field
							label="Monto Pagado CLP"
							v-model="orderPayment.amount"
							type="number"
							outlined
							required
							dense
							hide-details
							height="10px"
							style="font-size: 14px;"
							@keydown.enter.prevent
						></v-text-field>
						<div class="d-flex flex-row align-center my-4">
							<v-select
								v-model="orderPayment.method"
								:items="paymentMethods"
								:menu-props="{ top: true, offsetY: true }"
								item-text="name"
								item-value="name"
								label="Forma de Pago"
								class=" mr-2"
								outlined
								dense
								required
								hide-details
							></v-select>

							<v-menu
								ref="menu"
								v-model="menuDatePicker"
								:close-on-content-click="false"
								:return-value.sync="orderPayment.payment_date"
								transition="scale-transition"
								offset-y
								min-width="auto"
								eager
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										label="Fecha de Pago"
										v-model="orderPayment.payment_date"
										outlined
										required
										dense
										hide-details
										class=""
										style="font-size: 14px;"
										readonly
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="orderPayment.payment_date"
									no-title
									scrollable
									:first-day-of-week="1"
									locale="es-cl"
									:picker-date.sync="pickerDate"
									event-color="red lighten-1"
									@input="(date) => $refs.menu.save(date)"
									class="pb-4"
								/>
							</v-menu>
						</div>

						<v-text-field
							label="Concepto"
							v-model="orderPayment.concept"
							outlined
							required
							dense
							hide-details
							class=""
							style="font-size: 14px;"
							@keydown.enter.prevent
						></v-text-field>

						<div class="d-flex align-center my-2">
							<div class="px-0">
								<v-btn
									depressed
									color="#524D4D"
									small
									outlined
									:loading="loading"
									:disabled="!!fileToUpload"
									@click="showFilePicker"
								>
									<v-icon small>mdi-file-document-plus-outline</v-icon>
									<p class="mb-0 ml-2 caption">Agregar Comprobante</p>
								</v-btn>
								<input 
									type="file" 
									ref="fileInput"
									style="display: none;"
									:accept="acceptedFileTypes"
								/>
							</div>
							<div class="d-flex justify-space-between align-center mx-2" v-if="fileToUpload">
								<p class="mb-0 caption truncate-text">Archivo: <b>{{fileToUpload.name}}</b></p>
								<v-btn
									depressed
									color="#524D4D"
									small
									icon
									@click="fileToUpload = null"
								>
									<v-icon small>mdi-close-outline</v-icon>
								</v-btn>
							</div>
						</div>
					</v-form>
				</div>

				<v-divider class="my-2"></v-divider>

				<div class="py-1 d-flex justify-space-between" style="gap: 5px;">
					<v-btn
						x-small
						color="#2D4B95"
						text
						v-if="!checkFullPayments"
						@click="togglePaymentForm"
					>
						<v-icon x-small class="mr-1">mdi-plus</v-icon>
						Agregar Pago
					</v-btn>
					<div v-else>
						<p class="mb-0 caption light-blue-text">Monto total facturado (100%)</p>
						<p class="mb-0 caption light-blue-text"><b>CLP {{getTotalPayed.toLocaleString()}}</b></p>
					</div>
					<div class="d-flex" style="gap: 5px;"
							v-if="showPaymentForm">
						<v-btn
							x-small
							text
							@click="closeForm"
						>
							Cancelar
						</v-btn>
						<v-btn
							x-small
							color="#2D4B95"
							dark
							:loading="loading"
							@click="confirmPayment"
						>
							Confirmar
						</v-btn>
					</div>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
import {createManualPayment} from '@/helpers/api/payments'

export default {
	name: 'AGPPayments',
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	computed: {
		prependToValue(){
			const code = this.item?.currency_info?.code || 'CLP'
			const symbol = this.item?.currency_info?.symbol ||'$'
			if(code != symbol){
				return `${code} ${symbol}`
			}
			return code
		},
		checkFullPayments(){
			const totalPayed = this.getTotalPayed
			return totalPayed >= this.item.total_sum
		},
		getTotalPayed(){
			return this.item.payments.reduce((total, payment) => {
				return total + payment.amount
			}, 0)
		},
		payedPercentage(){
			return this.getTotalPayed / this.item.total_sum
		},
		acceptedFileTypes() {
			return [
				'application/pdf',
				'image/jpeg',
				'image/png',
			].join(',');
		},
	},
	data() {
		return {
			validform: false,
			loading: false,
			showPaymentForm: false,
			orderPayment: {
				payer_id: null,
				amount: 0,
				concept: null,
				item_id: this.item?.id,
				item_type: 'global_payment_status_additional',
				method: 'Transferencia Bancaria',
				payment_date: new Date().toISOString().split('T')[0],
			},
			paymentMethods: [
				{name: 'Transferencia Bancaria'},
				{name: 'Cheque'},
				{name: 'Efectivo'},
				{name: 'Tarjeta de Crédito/Débito'},
				{name: 'Otro'},
			],
			menuDatePicker: false,
			menuPayments: false,
			pickerDate: null,
			fileToUpload: null
		}
	},
	mounted() {
		this.orderPayment = {
			...this.orderPayment,
			item_id: this.item.id,
			item_type: 'global_payment_status_additional',
		}
	},
	methods: {
    closeForm(keepModal = false){
			this.menuPayments = keepModal
			this.showPaymentForm = false
			this.loading = false
			this.fileToUpload = null
			this.orderPayment = {
				payer_id: null,
				amount: 0,
				concept: null,
				item_id: this.item.id,
				item_type: 'global_payment_status_additional',
				method: 'Transferencia Bancaria',
				payment_date: new Date().toISOString().split('T')[0],
			}
      this.validform = true
    },
		togglePaymentForm() {
			this.showPaymentForm = !this.showPaymentForm
		},
		showFilePicker() {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0]
				this.fileToUpload = file
				input.value = null
			};
			input.click();
		},
		async confirmPayment(){
			if(!this.fileToUpload){
				this.setMessage({
					message: 'Por favor selecciona un comprobante de pago.',
					title: 'Comprobante Requerido',
					type: 'error',
					icon: 'mdi-alert-circle',
					color: 'red'
				})
				return
			}
			if(this.$refs.form.validate()){
				// this.loading = true
				const data = {
					...this.orderPayment,
					...{
						company_id: this.$store.projectsStore.state.selectedProject.company_id,
						amount: parseFloat(this.orderPayment.amount),
						item_id: parseInt(this.item.id),
						payment_date: `${this.orderPayment.payment_date} 12:00:00`,
						file: this.fileToUpload
					}
				}
				const formData = new FormData();
				Object.entries(data).forEach(([key, value]) => {
					if(value !== null && value !== undefined){
						formData.append(key, value);
					}
				});
				const response = await createManualPayment(formData)
				if(response.code == 200){
					this.$emit('reloadAdditionalInformativeTable')
					this.setMessage({
						message: 'Pago creado exitosamente',
						title: 'Pago Creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: 'green'
					})
					this.closeForm()
				}else{
					this.setMessage({
						message: response.message || 'Error al crear el pago',
						title: 'Error',
						type: 'error',
						icon: 'mdi-alert-circle',
						color: 'red'
					})
				}
				this.loading = false
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.globalStore.dispatch('addMessage', data)
    },
	}
}
</script>

<style scoped>
	.light-blue-text{color: #5E85EF;}
</style>